// extracted by mini-css-extract-plugin
module.exports = {"card":"RichText_card__SiJbX","cardError":"RichText_cardError__Ejo5F"};